import * as yup from "yup";

// ========================================
// Applicant Authentication Validations
// ========================================

export const applicantloginrule = yup.object({
  emailaddress: yup.string().email("Invalid email address given").required("Valid email address is required"),
  password: yup
    .string()
    .min(8, "Minimum of 8 characters expected")
    .max(32, "Maximum of 32 characters expected")
    .required("Password is a required fields"),
});

export const createapplicantrules = yup.object({
  firstname: yup.string().required("First name is a required field"),
  lastname: yup.string().required("Last name is a required field"),
  emailaddress: yup.string().email("Invalid email address").required("Valid email address is required"),
  jamb: yup.string().required("JAMB Admission number is a required field"),
  nin: yup
    .string()
    .nullable()
    .test("is-valid-nin", "NIN must be exactly 11 digits", function (value) {
      if (!value || value === "") return true; // Optional field
      return /^\d{11}$/.test(value);
    }),
  countrycode: yup.string().required("Country code is required"),
  phonenumber: yup
    .string()
    .matches(/^\d{10,11}$/, "Phone number must be 10-11 digits without country code")
    .required("Phone number is a required field"),
  password: yup
    .string()
    .min(8, "Minimum of 8 characters expected")
    .max(32, "Maximum of 32 characters expected")
    .required("Password is a required field"),
  confirmpassword: yup.string().oneOf([yup.ref("password"), null], "Passwords must match"),
  security_question: yup.string().required("Security question is required"),
  security_answer: yup.string().required("Security answer is required"),
});

export const forgetpasswordrules = yup.object({
  emailaddress: yup.string().email("Invalid email address").required("Valid email address is required"),
});

// ========================================
// Bio Data Validations
// ========================================

export const createapplicantbiorules = yup.object({
  firstname: yup.string().min(1, "First name is a required field").required("First name is a required field"),
  lastname: yup.string().min(1, "Last name is a required field").required("Last name is a required field"),
  dateofbirth: yup.date().required("Date of birth is a required field"),
  gender: yup.string().required("Gender is a required field"),
  religion: yup.string().required("Religion is a required field"),
  qualification: yup.string().required("Qualification is a required field"),
  maritalstatus: yup.string().required("Marital status is a required field"),
  emailaddress: yup.string().email("Invalid email address").required("Email address is a required field"),
  phonenumber: yup
    .string()
    .matches(/^(0\d{10}|234\d{10})$/, "Phone number must be 0XXXXXXXXXX or 234XXXXXXXXXX")
    .required("Phone number is a required field"),
  homeaddress: yup.string().required("Contact address is a required field"),
  stateoforigin: yup.string().required("State of origin is a required field"),
  stateofresidence: yup.string().required("State of residence is a required field"),
  lgaoforigin: yup.string().required("LGA of origin is a required field"),
  lgaofresidence: yup.string().required("LGA of residence is a required field"),
});

// ========================================
// Referee/Guardian Validations
// ========================================

export const createrefereerule = yup.object({
  firstname: yup.string().required("First name is a required field"),
  lastname: yup.string().required("Last name is a required field"),
  phonenumber: yup
    .string()
    .matches(/^(0\d{10}|234\d{10})$/, "Phone number must be 0XXXXXXXXXX or 234XXXXXXXXXX")
    .required("Phone number is a required field"),
  homeaddress: yup.string().required("Referee address is a required field"),
});

// ========================================
// O-Level Sitting Validations
// ========================================

export const createOLevelSitting = yup.object({
  examinationtype: yup.string().min(1, "Examination type is a required field").required("Examination type is a required field"),
  examinationcenter: yup.string().min(1, "Examination center number is a required field").required("Examination center number is a required field"),
  examinationyear: yup
    .string()
    .min(4, "Year of examination cannot be less than 4 character")
    .max(4, "Year of examination cannot be above 4 characters")
    .required("Year of examination is a required field"),
  examinationnumber: yup.string().required("Examination number is a required field"),
});

// ========================================
// O-Level Result Validations
// ========================================

export const createOLevelResult = yup.object({
  examination: yup.string().required("Examination is a required field"),
  scored: yup.string().required("Examination result is a required field"),
  subject: yup.string().required("Examination Subject is a required field"),
});

export const deleteResult = yup.object({
  delete: yup.string().required("Delete is a required field").oneOf(["Delete"], "Delete is the expected value"),
});

// ========================================
// A-Level Validations
// ========================================

export const IJMBValidation = yup.object({
  institutionName: yup.string().required("Institution name is a required field"),
  yearOfGraduation: yup.string().required("Year of graduation is  a required field"),
  educationSubject: yup.string().required("Education subject is a required field"),
  educationSubjectGrade: yup.string().required("Education subject grade is a required field"),
  educationSubject2: yup.string().required("Education subject 2 is a required field"),
  educationSubject2Grade: yup.string().required("Education subject 2 grade is a required field"),
  educationSubject3: yup.string().required("Education subject 3 is a required field"),
  educationSubject3Grade: yup.string().required("Education subject 3 grade is a required field"),
});

export const DiplomaValidation = yup.object({
  institutionName: yup.string().required("Institution name is a required field"),
  yearOfGraduation: yup.string().required("Year of graduation is  a required field"),
  courseOfStudy: yup.string().required("Course of study is a required field"),
  classification: yup.string().required("Classification of grade is a required field"),
  diplomaType: yup.string().required("Type of diploma is a required field"),
  cgpa: yup.string().required("CGPA is a required field"),
});

export const NCEValidation = yup.object({
  institutionName: yup.string().required("Institution name is a required field"),
  yearOfGraduation: yup.string().required("Year of graduation is  a required field"),
  educationSubject: yup.string().required("Education subject is a required field"),
  educationSubjectGrade: yup.string().required("Education subject grade is a required field"),
  educationSubject2: yup.string().required("Education subject 2 is a required field"),
  educationSubject2Grade: yup.string().required("Education subject 2 grade is a required field"),
  educationSubject3: yup.string().required("Education subject 3 is a required field"),
  educationSubject3Grade: yup.string().required("Education subject 3 grade is a required field"),
});

export const ALevelResultValidation = yup.object({
  type: yup.string().required("Result type is required"),
  results: yup.object().required("Result information is required"),
});

// ========================================
// Waiver Code Validation
// ========================================

export const applyWaiverCode = yup.object({
  waiverCode: yup.string().required("Waiver code is a required field"),
});
